import script from "./CountdownArea.vue?vue&type=script&setup=true&lang=js"
export * from "./CountdownArea.vue?vue&type=script&setup=true&lang=js"

import "./CountdownArea.vue?vue&type=style&index=0&id=04750a8f&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04750a8f"]])

export default __exports__